import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState } from 'react';
import { tLoc } from '../../i18n/translate.js';
import { CODE_WORD_MIN_LENGTH, CODE_WORD_MAX_WORDS } from '../../services/appConstants/appConstants.js';

var CODE_WORD_CHARACTERS_REGEXP = /^[a-zA-Z0-9åäöæøèéëüÅÄÖÆØÈÉËÜ ]*$/;
var getValidationErrorLabel = function getValidationErrorLabel(_ref) {
  var code = _ref.code,
    confirm = _ref.confirm;
  var trimmedCode = code.trim();
  var trimmedConfirm = confirm.trim();
  if (trimmedCode.length > 0 && trimmedCode.length < CODE_WORD_MIN_LENGTH) {
    return 'MPLIB_CODE_WORD_VALIDATION_MIN_LENGTH';
  }
  if (trimmedCode.split(' ').length > CODE_WORD_MAX_WORDS) {
    return 'MPLIB_CODE_WORD_VALIDATION_MAX_WORDS';
  }
  if (!CODE_WORD_CHARACTERS_REGEXP.test(trimmedCode)) {
    return 'MPLIB_CODE_WORD_VALIDATION_CHAR_SET';
  }
  if (trimmedCode !== trimmedConfirm) {
    return 'MPLIB_CODE_WORD_NO_MATCH';
  }
  return null;
};
var useCodeWordInputUtils = function useCodeWordInputUtils() {
  var _customerCode$code, _securitasCode$code, _customerCode$code2, _customerCode$code2$t, _securitasCode$code2, _securitasCode$code2$;
  var initialState = {
    code: '',
    confirm: ''
  };
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    customerCode = _useState2[0],
    setCustomerCode = _useState2[1];
  var _useState3 = useState(initialState),
    _useState4 = _slicedToArray(_useState3, 2),
    securitasCode = _useState4[0],
    setSecuritasCode = _useState4[1];
  var customerCodeValid = getValidationErrorLabel(customerCode) === null;
  var customerCodeChanged = Boolean((_customerCode$code = customerCode.code) === null || _customerCode$code === void 0 ? void 0 : _customerCode$code.trim());
  var securitasCodeValid = getValidationErrorLabel(securitasCode) === null;
  var securitasCodeChanged = Boolean((_securitasCode$code = securitasCode.code) === null || _securitasCode$code === void 0 ? void 0 : _securitasCode$code.trim());
  var anyChange = customerCodeChanged || securitasCodeChanged;
  var canSave = anyChange && customerCodeValid && securitasCodeValid;
  var shouldSaveCustomerCode = customerCodeValid && customerCodeChanged;
  var shouldSaveSecuritasCode = securitasCodeValid && securitasCodeChanged;
  var commonValidation = customerCode.code.trim().length > 0 && securitasCode.code.trim().length > 0 && canSave;
  var codeAreEqual = ((_customerCode$code2 = customerCode.code) === null || _customerCode$code2 === void 0 ? void 0 : (_customerCode$code2$t = _customerCode$code2.trim()) === null || _customerCode$code2$t === void 0 ? void 0 : _customerCode$code2$t.toLowerCase()) === ((_securitasCode$code2 = securitasCode.code) === null || _securitasCode$code2 === void 0 ? void 0 : (_securitasCode$code2$ = _securitasCode$code2.trim()) === null || _securitasCode$code2$ === void 0 ? void 0 : _securitasCode$code2$.toLowerCase());
  var allValid = commonValidation && !codeAreEqual;
  var wordsCannotBeEqualErrorLabel = commonValidation && codeAreEqual ? tLoc('MPLIB_CODE_WORD_CANNOT_BE_EQUAL') : null;
  var setInitialState = function setInitialState() {
    setCustomerCode(initialState);
    setSecuritasCode(initialState);
  };
  return {
    canSave: canSave,
    anyChange: anyChange,
    setInitialState: setInitialState,
    customerCode: customerCode,
    setCustomerCode: setCustomerCode,
    securitasCode: securitasCode,
    setSecuritasCode: setSecuritasCode,
    shouldSaveCustomerCode: shouldSaveCustomerCode,
    shouldSaveSecuritasCode: shouldSaveSecuritasCode,
    allValid: allValid,
    wordsCannotBeEqualErrorLabel: wordsCannotBeEqualErrorLabel
  };
};

export { getValidationErrorLabel, useCodeWordInputUtils };
